<template>
  <div class="table-container">
    <div class="header">
      <div class="title">{{ $t('articles') }} ({{ lastRequest && lastRequest.data && lastRequest.data.count ? lastRequest.data.count : 0 }})</div>
      <RouterLink class="main-button" to="/admin/article/add">
        {{ $t('addArticle') }}
      </RouterLink>
    </div>

    <div class="table hide-medium" border="0" cellspacing="0" cellpadding="0">
      <div class="table-header flex">
        <div v-for="data in headers" :key="data" class="table-header-item">
          {{ data }}
        </div>
      </div>

      <div class="table-content">
        <div v-for="article in tableValues" :key="article.publicId" class="articles">
          <div class="table-line">
            <div class="table-item">
              <div class="item bold" v-html="article.title" />
            </div>
            <div class="table-item">
              <div class="item">
                {{ $utils.formatDate(article.publishedAt) }}
              </div>
            </div>
            <div class="table-item">
              <div class="item">
                {{ article.isPublished ? $t('published') : $t('unpublished') }}
              </div>
            </div>
            <div class="table-item last">
              <div class="item">
                <div class="link-button" @click.stop="() => selectArticle(article)">
                  {{ $t('edit') }}
                </div>
              </div>
              <div class="item">
                <div class="link-button grey" @click.stop="() => deleteArticle(article)">
                  {{ $t('delete') }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="dropdown-article"
            :class="{
              visible: article.publicId === selectedArticle && !loading,
            }"
            :style="{
              height: `${article.publicId === selectedArticle ? 'fit-content' : 0 + 'px'}`,
            }"
            @click.stop="() => null"
          >
            <div class="article-container-create">
              <div class="article-content">
                <img :src="base64Img ? base64Img : article.imageUrl ? article.imageUrl : placeholder" alt="" />
              </div>
              <div class="article-content">
                <div class="main-button" :class="{ disable: false }" @click.stop="openInput">
                  {{ $t('upload.chooseFile') }}
                </div>
              </div>
              <ArticleEditor v-model="article.title" :title="$t('title')" height="90px" :maxlength="200" />

              <ArticleEditor v-model="article.resume" :title="$t('summary')" height="160px" :maxlength="1000" />

              <ArticleEditor v-model="article.content" :title="$t('content')" height="500px" :maxlength="8000" />

              <VideoEditor v-model="iframeHTML" :update-video="updateVideo" :article="article" @set-video-update="setVideoUpdate" @new-content="newContent" />

              <div class="article-content">
                <div class="publish" @click="publish = !publish">
                  <div class="checkbox" :class="{ checked: publish }"></div>
                  <div class="checkbox-label">{{ $t('publish') }}</div>
                </div>
              </div>

              <div class="article-content">
                <div class="main-button cancel" @click.stop="cancel">
                  {{ $t('cancel') }}
                </div>
                <div class="main-button" :class="{ disable: false }" @click.stop="() => edit(article)">
                  {{ $t('change') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pagination
      v-if="tableValues && tableValues.length"
      :pagination="pagination"
      :set-page="setPage"
      :tableValues="tableValues"
      :pages="pages"
      :disable-dots="disableDots"
    />
    <input :ref="'inputFile'" type="file" accept=".png, .jpeg, .jpg" class="input-file" hidden @change="uploadFile({}, $event)" />
  </div>
</template>

<script>
import placeholder from '@/assets/placeholder-upload.jpg';
import ArticleEditor from '@/components/ArticleEditor.vue';
import Pagination from '@/components/Pagination';
import tableMixin from '@/components/tables/TableMixin';
import VideoEditor from '@/components/VideoEditor.vue';

export default {
  components: { Pagination, ArticleEditor, VideoEditor },
  mixins: [tableMixin],

  beforeRouteLeave(to, from, next) {
    if (this.isSend) return next();
    if (this.selectedArticle && this.selectedArticle !== -1 && confirm(this.$t('areYouSureToExit'))) {
      return next();
    } else if (!(this.selectedArticle && this.selectedArticle !== -1) && !(this.titleSelected || this.resume || this.content || this.file)) {
      return next();
    }
  },

  data() {
    return {
      placeholder,
      selectedArticle: -1,
      headers: [this.$t('lastName'), this.$t('creationDate'), this.$t('statut'), ''],
      publish: false,
      values: [],
      loading: false,
      tableMixinConfig: {
        backendPaginated: true,
        onChange: this.changePage,
        getData: this.getData,
        maxElement: 5,
      },
      forceRecomputeCounter: 0,
      file: null,
      base64Img: null,
      titleSelected: '',
      resume: '',
      content: '',
      iframeHTML: '',
      updateVideo: false,
    };
  },

  computed: {},

  methods: {
    cancel() {
      this.selectedArticle = -1;
    },

    async deleteArticle(article) {
      if (await this.$store.dispatch('setPopup', { popupType: 'Confirm' })) {
        await this.$store.dispatch('deleteArticle', { id: article.publicId });
        this.setPage(0);
      }
    },

    encodeImage(input) {
      if (input) {
        const reader = new FileReader();
        reader.onload = e => {
          this.base64Img = e.target.result;
        };
        reader.readAsDataURL(input);
      }
    },

    async edit(article) {
      const data = new FormData();
      article.content = this.content || article.content;
      article.content += this.iframeHTML;
      data.append('title', article.title);
      data.append('resume', article.resume);
      data.append('content', article.content);
      data.append('Image', this.file);
      data.append('IsPublished', this.publish);
      const result = await this.$store.dispatch('editArticle', {
        id: article.publicId,
        data,
      });
      this.selectedArticle = -1;
      this.iframeHTML = '';
      this.youTubeUrl = '';
      this.getData();
      this.updateVideo = false;
      return result;
    },

    openInput() {
      this.$refs[`inputFile`].click();
    },

    async uploadFile(_, event) {
      if (!event.target.files[0]) {
        return;
      }
      this.file = event.target.files[0];
      this.encodeImage(this.file);
    },

    async selectArticle(article) {
      this.selectedArticle = this.selectedArticle === article.publicId ? -1 : article.publicId;
      this.publish = article.isPublished;
    },

    async getData(pageNumber = 0, pageSize = this.tableMixinConfig.maxElement) {
      this.loading = true;
      const data = await this.$store.dispatch('getArticles', {
        pageNumber,
        pageSize,
      });
      this.values = data.items;
      this.loading = false;
      this.pagination.totalLength = data.count;
      this.pagination.maxPage = Math.ceil(this.pagination.totalLength / this.pagination.maxElement);
      return { data, values: data.items };
    },

    setVideoUpdate(value) {
      this.updateVideo = value;
    },

    newContent(content) {
      this.content = content;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
@use '@/styles/variables.scss';
.table-container {
  .header {
    margin: 60px 0 0;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: flex-end;
      font-weight: 500;
      font-size: 20px;
    }

    .main-button {
      min-width: 240px;
      padding: 0;
    }
  }
}

.table {
  border-bottom: none;
}

.table .table-header,
.table .table-content {
  &.flex {
    display: flex;

    .table-header-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(33.3%);
    }
  }

  &.table-content {
    flex-direction: column;

    .articles .dropdown-article {
      height: 0;
      overflow: hidden;
      transition: all 0.2s;
      opacity: 0;
      box-sizing: border-box;

      &.visible {
        border-bottom: 1px solid colors.$border-color;
        opacity: 1;
        padding: 42px 180px;
      }

      .title {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 20px;
        margin: 0 0 24px;

        &:not(:first-child) {
          padding-top: 24px;
        }
      }

      .article-content-create {
        flex-grow: 1;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 1px solid colors.$lightgrey-color;
        border-radius: 5px;
        padding: 30px;
        transition: all 0.3s;
        overflow-y: auto;

        &.article-title {
          min-height: 90px;
          max-height: 90px;
        }

        &.summary {
          max-height: 160px;
          min-height: 160px;
        }

        &.article-ct {
          max-height: 500px;
          min-height: 500px;
        }

        &:focus {
          border-radius: 5px !important;
          border: 1px solid colors.$lightblue-color;
          outline: none;
        }

        &.placeholder {
          color: colors.$grey-color;
        }
      }

      .line {
        display: flex;
        justify-content: space-between;

        .filters {
          align-self: flex-end;
          flex-grow: 1;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          height: 0;
          overflow: hidden;
          transition: all 0.3s;
          opacity: 0;

          &.enabled {
            height: 30px;
            opacity: 1;
          }

          .filter-btn {
            width: 36px;
            box-sizing: border-box;
            border: 1px solid colors.$lightgrey-color;
            margin-bottom: 6px;
            padding: 4px;
            border-radius: 4px;
            cursor: pointer;

            &.bold {
              font-weight: bold;
            }

            &.italic {
              font-style: italic;
            }

            &.underline {
              text-decoration: underline;
            }

            &:hover {
              background: colors.$lightgrey-color;
              border-color: colors.$grey-color;
            }

            &:not(:first-child) {
              border-left: 0;
            }

            &:nth-child(2n) {
              border-radius: 0;
            }

            &:first-child {
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
            }

            &:last-child {
              border-top-left-radius: 0px;
              border-bottom-left-radius: 0px;
            }
          }
        }
      }

      .article-content {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;

        .publish {
          display: flex;

          &:hover {
            cursor: pointer;
          }

          .checkbox-label {
            margin-left: 8px;
          }
        }

        img {
          width: 400px;
          max-height: 400px;
          box-shadow: variables.$box-shadow;
          border-radius: 3px;
        }

        .info {
          height: 100%;
          color: colors.$red-color;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
        }

        .main-button {
          margin-top: 24px;
          max-width: 160px;
          cursor: pointer;

          &.disable {
            cursor: not-allowed;
            background: colors.$lightgrey-color;
          }

          &.delete {
            background: colors.$red-color;
          }
          &.cancel {
            background: colors.$lightgrey-color;
            color: colors.$darkgrey-color;
          }
        }
      }
    }
  }
}

.table .table-content .table-line {
  display: flex;
  width: 100%;
  background: colors.$white-color;

  .table-item {
    &.last {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-around;

      .item,
      .link-button {
        width: fit-content;
        text-align: right;
      }
    }
  }

  &:last-child .table-item {
    border: none;

    .item {
      text-align: right;
    }
  }

  .table-item {
    width: calc(25%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;

    .item {
      width: 100%;
      color: colors.$darkgrey-color;
      font-size: 13px;
      font-weight: normal;
      display: flex;
      justify-content: center;

      &.bold {
        font-weight: 500;
      }
    }
  }
}
</style>
